<template>
  <div class="about-boat" :class="{ _open: isOpen }">
    <div class="about-boat__header">О теплоходе</div>

    <div class="about-boat__content">
      <div class="about-boat__head">
        <div class="about-boat__title">{{ fullName }}</div>
        <div class="about-boat__company">{{ shipCompany }}</div>
      </div>

      <div class="about-boat__slider">
        <MySlider
          class="cruise-info__slider"
          :slideRatio="1 / 2"
          :slides="photos"
          srcKey="src_next"
          idKey="id"
          titleKey="title"
        />
      </div>

      <div class="about-boat__info">
        <InsertHtml v-bind="descriptionBig" />
        <router-link
            :to="ship_link"
            class="about-boat__link"
            target="_blank"
        >
            Полное описание теплохода
        </router-link>
      </div>

      <div class="about-boat__action">
        <div
            class="about-boat__mask-action"
            @click.prevent="toggle"
        >
        </div>
        <button
            class="about-boat__btn-action"
            @click.prevent="toggle"
            >
        {{ isOpen ? 'Свернуть' : 'Развернуть' }}
        </button>    
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./ShipShort.scss"></style>

<script setup>
import { ref } from 'vue'
import useShip from "@/comp/useShip.js"
import MySlider from "@/comp/MySlider/MySlider.vue"
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'

const props = defineProps({
  ship: Object,
})

const isOpen = ref(false)

const toggle = () => {
  isOpen.value = !isOpen.value
}

const shipOb = useShip({ ship: props.ship })

const {
  name,
  fullName,
  shipCompany,
  ship_link,
  photos,
  descriptionBig,
} = shipOb
</script>
